import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-military-calisthenics-sh',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics-sh-m', 'age-military-calisthenics-sh-m'],
		route: {
			path: '/military-calisthenics-sh-m',
			name: 'male-military-calisthenics-sh-funnel',
		},
	},
	funnel: {
		id: 'ob-male-military-calisthenics-sh',
		route: {
			path: '/military-calisthenics-sh-m/ob/:page(.*)?',
			name: 'activity-male-military-calisthenics-sh',
		},
		slug: 'activity-male-military-calisthenics-sh',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-military-calisthenics-sh-m',
	},
	upsell: {
		routeNames: ['upsell-military-calisthenics-sh-m'],
	},
}

export default appAreaConfig
